export enum ROUTES {
    ACCESSMANAGEMENT = '/zugangsverwaltung',
    ACCOUNT_CONFIGURATOR = '/account-verwalten',
    AGB = '/agb',
    BARCODELIST = '/barcode-liste',
    CABLEREEL = '/abholung-kabeltrommel',
    CABLEREELSUCCESS = '/kabeltrommel-gesendet',
    CABLEDEALMARKET = '/kabelschnaeppchen',
    CALLBACK = '/callback',
    CART = '/warenkorb',
    CARTS = '/meine-warenkoerbe',
    CHANGELOG = '/neuigkeiten',
    CHECKOUT = '/bestelluebersicht',
    CHECKOUT_OFFER = '/angebot-bestelluebersicht',
    CHECKOUTSUCCESS = '/bestellung-erfolgreich',
    COCONTRACTOR_PORTAL = '/promotion/vertragspartnerportal',
    CONFIGURATORS = '/konfiguratoren',
    CREDIT_INFO = '/credits-info',
    CREDITS_DONATED_SUCCESS = '/credits-donated-success',
    ELBRIDGE = '/elbridge',
    FAQ = '/faq',
    FASTENTRY = '/schnellerfassung',
    FIVE_YEAR_GUARANTEE = '/promotion/5-jahres-garantie',
    HELP = '/hilfe',
    JUBILEE_CAMPAIGN = '/jubilaeumsaktion',
    KANBAN = '/etiketten',
    LASTBOUGHTPRODUCTS = '/zuletzt-gekaufte-produkte',
    MARKET_PRICE_DEVELOPMENT = '/promotion/marktpreisentwicklung',
    NEWSLETTER = '/newsletter-anmeldung',
    NEWS = '/magazin',
    OFFERS = '/meine-angebote',
    OFFERDETAILS = '/angebot-details',
    ONBOARDING = '/onboarding',
    ORDER = '/beleg-details',
    ORDERS = '/meine-belege',
    ORDERING_PERIOD = '/bestell-und-lieferzeiten',
    OWN_USER = '/eigener-benutzer',
    OXOMICATALOGUES = '/kataloge',
    OXOMI_NAVIGATOR = '/navigator',
    PRAEMIEN_SHOP = '/praemienshop',
    PRAEMIEN_SHOP_CART = '/praemienshop-warenkorb',
    PRAEMIEN_SHOP_DETAIL = '/praemienshop-detail',
    PRAEMIEN_SHOP_DONATION_SUCCESS = '/praemienshop-spende-erfolgreich',
    PRAEMIEN_SHOP_REGISTER = '/praemienshop-anmelden',
    PRAEMIEN_SHOP_SPEND_POINTS = '/praemienshop-punkte-spenden',
    PRAEMIEN_SHOP_SUCCESS = '/praemienshop-bestellung-erfolgreich',
    PRIVACY = '/datenschutz',
    PRODUCT_COMPARE = '/produkt-vergleich',
    PRODUCTPAGE = '/produkt',
    PROMOTION = '/promotion',
    PROMOTION_HELP = '/promotion/hilfe',
    PROMOTIONALSHEET = '/aktionsblatt',
    RECEIPT = '/wareneingang',
    RETURNS = '/meine-retouren',
    RETURNCHECKIN = '/retoure-anmelden',
    RETURNCHECKOUT = '/retoure-checkout',
    RETURNSUCCESS = '/retoure-erfolgreich',
    SCANNER = '/scanner',
    SEARCH = '/suche',
    SERVICEPORTAL = '/promotion/serviceportal',
    SERVICE_DIRECTORY = '/leistungsverzeichnis',
    SERVICE_DIRECTORY_DETAIL = '/leistungsverzeichnis-detail',
    SERVICES = '/services',
    SHOP = '/mein-shop',
    SHOPPINGLIST = '/liste',
    SHOPPINGLISTS = '/listen',
    SIGNUP = '/kunde-werden',
    SINGUPSUCCESS = '/registrierung-abgeschlossen',
    START = 'https://alexander-buerkle.com',
    TECSELECT = '/services/tecselect/',
    USER_CONFIGURATOR = '/benutzer-verwalten'
}

export enum EXTERNAL_ROUTES {
    ACADEMY = 'https://akademie.alexander-buerkle.com',
    MEHRUMSATZ_AKTION_2026 = 'https://web.alexander-buerkle.com/de/mehrumsatzaktion-2026',
    ALEXGREEN = 'https://web.alexander-buerkle.com/de/ganzheitliche-loesungen/alexgreen',
    FACEBOOK = 'https://www.facebook.com/alexander.buerkle.de',
    FUNDING_COMPASS = 'https://abuerkle.link/foerdkompass-onlineshop',
    INSTAGRAM = 'https://www.instagram.com/alexander.buerkle/',
    ITSHOP_LOGIN = 'https://itshop.alexander-buerkle.de/login',
    KANBAN_LABEL_SETS = 'https://web.alexander-buerkle.com/de/kanban-label-sets',
    LINKEDIN = 'https://www.linkedin.com/company/alexander-buerkle/',
    KATALOGE = 'https://web.alexander-buerkle.com/de/catalogues',
    NEWSLETTER = 'https://go.alexander-buerkle.com/newsletteranmeldung-start/',
    OLD_SHOP_ARTICLE = 'https://shop.alexander-buerkle.de/article/articleinfo',
    OLD_SHOP_LOGIN = 'https://shop.alexander-buerkle.de/login',
    ORDER_STATUS_PORTAL = 'https://auftragsstatus.alexander-buerkle.com/',
    OXOMI_NAVIGATOR = 'https://web.alexander-buerkle.com/de/oxomi-navigator',
    TECSELECT_INFO = 'https://www.tecselect.de/',
    XING = 'https://www.xing.com/pages/alexanderburklegmbh-co-kg',
    YOUTUBE = 'https://www.youtube.com/user/AlexanderBuerkle',
    INTERFACES = 'https://web.alexander-buerkle.com/de/ganzheitliche-loesungen/ecommerce-schnittstellen'
}
